import React from "react";
import PropTypes from "prop-types";
import Checkbox from "shared/@forms/Checkbox";
import styles from "./CheckBoxItem.module.css";

/**
 * Interactive component.
 * Check box used to select filters.
 */
export function CheckBoxItem({ checked, name, onClick }) {
  return (
    <div className={styles.container}>
      <div className={styles["input-container"]}>
        <Checkbox
          className={styles.input}
          checked={checked}
          name={name}
          onClick={onClick}
        />
      </div>
      <label htmlFor={name}>{name}</label>
    </div>
  );
}

CheckBoxItem.propTypes = {
  /**
   * Decides if the box is checked.
   */
  checked: PropTypes.bool,
  /**
   * Label for checkbox.
   */
  name: PropTypes.string,
  /**
   * Function that fires when the box is clicked.
   */
  onClick: PropTypes.func,
};
